"use client";

import { getSkills } from "@/services/skill";
import SkillCard from "./SkillCard";

import Title from "../sharepage/Title";
import SkillImage from "./SkillImage";
import { useEffect, useState } from "react";
const tabs = ["frontend", "backend", "tools"];
// Server component
export default function Skills() {
  const [activeTab, setActiveTab] = useState("frontend");
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const fetchSkills = async () => {
      const res = await getSkills(activeTab);
      setSkills(res?.data || []);
    };

    fetchSkills();
  }, [activeTab]);

  return (
    <section className="py-10">
      <div className="space-y-6 text-center lg:space-y-8">
        <Title title="My Skills" />

        <div className="grid gap-10 lg:grid-cols-2">
          <div className="">
            <div className="flex justify-center pb-10 gap-3">
              {tabs?.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`p-4 w-full rounded-lg text-sm capitalize font-medium transition-all
              ${activeTab === tab ? "bg-rose-500 text-white" : "bg-base-300"}`}
                >
                  {tab}
                </button>
              ))}
            </div>
            {/* Skill Cards */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
              {skills?.map((skill, index) => (
                <SkillCard skill={skill} key={index} index={index} />
              ))}
            </div>
          </div>

          {/* Animation (Lottie) */}
          <div>
            <SkillImage />
          </div>
        </div>
      </div>
    </section>
  );
}
